import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics, isSupported } from "firebase/analytics";
import type { Analytics } from "firebase/analytics";

// Firebase配置 - 使用环境变量
const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// 验证必需的Firebase配置
const requiredEnvVars = [
    'VITE_FIREBASE_API_KEY',
    'VITE_FIREBASE_AUTH_DOMAIN',
    'VITE_FIREBASE_PROJECT_ID',
    'VITE_FIREBASE_STORAGE_BUCKET',
    'VITE_FIREBASE_MESSAGING_SENDER_ID',
    'VITE_FIREBASE_APP_ID'
];

const missingEnvVars = requiredEnvVars.filter(
    varName => !import.meta.env[varName]
);

if (missingEnvVars.length > 0) {
    throw new Error(
        `Missing required Firebase environment variables: ${missingEnvVars.join(', ')}\n` +
        'Please check your .env file and ensure all Firebase configuration variables are set.'
    );
}
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// 初始化Firebase Authentication并获取引用
export const auth = getAuth(app);

// 异步初始化Analytics
let analytics: Analytics | null = null;

// 初始化Analytics的异步函数
export const initializeAnalytics = async (): Promise<Analytics | null> => {
    if (typeof window === 'undefined') {
        return null;
    }

    try {
        const supported = await isSupported();
        if (supported && !analytics) {
            analytics = getAnalytics(app);
        }
        return analytics;
    } catch (error) {
        console.warn('Firebase Analytics initialization failed:', error);
        return null;
    }
};

// 获取Analytics实例
export const getAnalyticsInstance = (): Analytics | null => analytics;

export default app; 